import { AppRoutingModule } from './app-routing.module';
import { SriisModule } from './sriis/sriis.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserModule } from '@angular/platform-browser';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { AuthModule, UserEditModule } from './auth';
import { CoreModule } from './core/core.module';
import { LibraryModule } from './library/library.module';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    AuthModule,
    BrowserModule,
    CoreModule,
    FlexLayoutModule,
    LibraryModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatTooltipModule,
    SriisModule,
    UserEditModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
